import script from "./AlzguardTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlzguardTitle.vue?vue&type=script&setup=true&lang=ts"

import "./AlzguardTitle.vue?vue&type=style&index=0&id=3b2ddd5f&lang=css"

const __exports__ = script;

export default __exports__